import { useRef, useState } from 'react';
import { wrap } from '@motionone/utils';
import { useAnimationFrame, useMotionValue, useScroll, useSpring, useTransform, useVelocity } from 'framer-motion';
import { ITrendContent } from '@shared/models/groupTrend';
import { analytics } from '@shared/utils/segment.utils';
import Content from './Content';
import { ParallaxContainer, ParallaxScroller } from './TrendAnimation.style';
interface Props {
  content: ITrendContent[];
  baseVelocity: number;
  isHover: boolean;
  onClickContent: (slugUrl: string) => void;
}
const ParallaxContent = ({
  content,
  baseVelocity = 100,
  isHover,
  onClickContent
}: Props) => {
  const baseX = useMotionValue(0);
  const {
    scrollY
  } = useScroll();
  const scrollVelocity = useVelocity(scrollY);
  const smoothVelocity = useSpring(scrollVelocity, {
    damping: 50,
    stiffness: 400
  });
  const velocityFactor = useTransform(smoothVelocity, [0, 1000], [0, 5], {
    clamp: false
  });

  /**
   * This is a magic wrapping for the length of the text - you
   * have to replace for wrapping that works for you or dynamically
   * calculate
   */
  const x = useTransform(baseX, v => `${wrap(-20, -45, v)}%`);
  const directionFactor = useRef<number>(1);
  useAnimationFrame((t, delta) => {
    let moveBy = directionFactor.current * baseVelocity * (delta / 1000);

    /**
     * This is what changes the direction of the scroll once we
     * switch scrolling directions.
     */
    if (velocityFactor.get() < 0) {
      directionFactor.current = -1;
    } else if (velocityFactor.get() > 0) {
      directionFactor.current = 1;
    }
    moveBy += directionFactor.current * moveBy * velocityFactor.get();
    baseX.set(baseX.get() + moveBy);
  });

  /**
   * The number of times to repeat the child text should be dynamically calculated
   * based on the size of the text and viewport. Likewise, the x motion value is
   * currently wrapped between -20 and -45% - this 25% is derived from the fact
   * we have four children (100% / 4). This would also want deriving from the
   * dynamically generated number of children.
   */

  const [hoverIndex, setHoverIndex] = useState(-1);
  const handleOnClick = (title: string, slugUrl: string) => {
    analytics.track('Group Train Click', {
      event: 'Group Train Click',
      group_name: title
    });
    onClickContent(slugUrl);
  };
  return <ParallaxContainer>
            <ParallaxScroller style={{
      x
    }}>
                {content.map(({
        text,
        icon,
        color,
        tooltipText,
        slugUrl
      }, index) => {
        return <Content key={index} text={text} icon={icon} color={color} tooltipText={tooltipText} slugUrl={slugUrl} isHover={isHover && hoverIndex === index} contentIndex={index} setHoverIndex={setHoverIndex} onClick={() => handleOnClick(text, slugUrl)} />;
      })}
            </ParallaxScroller>
        </ParallaxContainer>;
};
export default ParallaxContent;